module.exports = __webpack_public_path__ + "img/figure03_sp.73b351db.png";